import currency from 'currency.js';
import { DEFAULT_PRECISION } from '@/utils/produto-utils';

function total(compra) {
  if (!compra.produtos.length) {
    return compra.frete.totalTransporte;
  }
  const produtos = compra.produtos
    .map(produto => currency(produto.total, { precision: DEFAULT_PRECISION }).value)
    .reduce((a, b) => currency(a, { precision: DEFAULT_PRECISION })
      .add(currency(b, { precision: DEFAULT_PRECISION })).value, 0);

  return currency(produtos, { precision: DEFAULT_PRECISION })
    .add(currency(compra.frete.totalTransporte, { precision: DEFAULT_PRECISION }))
    .value;
}

function calculateTotalProdutos(compra) {
  return compra.produtos
    .map(a => currency(a.totalProdutos, { precision: DEFAULT_PRECISION }).value)
    .reduce((a, b) => currency(a, { precision: DEFAULT_PRECISION })
      .add(currency(b, { precision: DEFAULT_PRECISION })).value, 0);
}

function calculateTotalProdutosComImpostos(compra) {
  return compra.produtos
    .map(a => a.total)
    .reduce((a, b) => currency(a, { precision: DEFAULT_PRECISION })
      .add(currency(b, { precision: DEFAULT_PRECISION })).value, 0);
}

function calculateTotalProduto(produto) {
  return currency(produto.quantidade, { precision: DEFAULT_PRECISION })
    .multiply(currency(produto.precoUnitario, { precision: DEFAULT_PRECISION }))
    .value;
}

function calculateIcms(produto) {
  if (!produto.impostos && !produto.impostos.icms) {
    return 0;
  }
  const { totalProdutos } = produto;
  const icms = currency(produto.impostos.icms, { precision: DEFAULT_PRECISION })
    .multiply(100);
  return icms.multiply(currency(totalProdutos, { precision: DEFAULT_PRECISION }))
    .divide(100).value;
}

function calculateIpi(produto) {
  if (!produto.impostos && !produto.impostos.ipi) {
    return 0;
  }
  const ipi = currency(produto.impostos.ipi, { precision: DEFAULT_PRECISION }).multiply(100);
  const valorBase = currency(produto.totalProdutos, { precision: DEFAULT_PRECISION })
    .add(currency(produto.frete, { precision: DEFAULT_PRECISION }));

  return ipi.multiply(valorBase).divide(100).value;
}

function calculateTotal(produto) {
  return currency(produto.totalProdutos, { precision: DEFAULT_PRECISION })
    .add(currency(produto.impostos.valorIpi, { precision: DEFAULT_PRECISION }))
    .value;
}

function calculateSavingForProduto(produto) {
  return currency(produto.$$itemTabelaPreco.saving, { precision: DEFAULT_PRECISION })
    .multiply(produto.quantidade)
    .value;
}

function calculateSavingFromProdutos(produtos) {
  const produtosComTabelaESaving = produtos
    .filter(produto => produto.$$itemTabelaPreco && produto.$$itemTabelaPreco.saving);

  return produtosComTabelaESaving
    .map(produto => calculateSavingForProduto(produto))
    .reduce((a, b) => currency(a, { precision: DEFAULT_PRECISION })
      .add(currency(b, { precision: DEFAULT_PRECISION })).value, 0);
}

function calculatePercentualRateio(produto, compra) {
  if (compra.frete.totalTransporte === 0) {
    return 0;
  }
  return currency(produto.totalProdutos, { precision: DEFAULT_PRECISION })
    .multiply(100)
    .divide(currency(calculateTotalProdutos(compra), { precision: DEFAULT_PRECISION }))
    .value;
}

function calculateFreteItem(produto, compra) {
  if (compra.frete.totalTransporte === 0) {
    return 0;
  }
  return currency(produto.percentualRateio, { precision: DEFAULT_PRECISION })
    .multiply(compra.frete.totalTransporte)
    .divide(100)
    .value;
}

function calculateProdutos(compra) {
  compra.produtos.forEach((produto) => { /* eslint-disable no-param-reassign */
    produto.totalProdutos = calculateTotalProduto(produto);
    produto.impostos.valorIcms = calculateIcms(produto);
  });
}

function calculateRateioIpiTotal(compra) {
  compra.produtos.forEach((produto) => { /* eslint-disable no-param-reassign */
    produto.percentualRateio = calculatePercentualRateio(produto, compra);
    produto.frete = calculateFreteItem(produto, compra);
    produto.impostos.valorIpi = calculateIpi(produto);
    produto.total = calculateTotal(produto);
  });
}

function calcularTotaisCompra(compra) {
  calculateProdutos(compra);
  calculateRateioIpiTotal(compra);

  return {
    total: total(compra),
    totalProdutos: calculateTotalProdutosComImpostos(compra),
  };
}

function calcularSaving(compra) {
  if (compra.saving) {
    return compra.saving;
  }
  return calculateSavingFromProdutos(compra.produtos);
}

export { calcularTotaisCompra, total, calcularSaving };
